import { Center, Td, Badge, ButtonGroup, Flex, IconButton, Container, Heading } from "@chakra-ui/react";
import { Form, Table, Row } from "components";
import { useStatementReport } from "hooks";
import { useEffect, useState } from "react";
import { Moment, Mask } from "config";
import { RepeatIcon } from "@chakra-ui/icons";
import { FaFileCsv } from "react-icons/fa";

export default function Statement() {

    const [dates, setDates] = useState()
    const [start, setStart] = useState()
    const [end, setEnd] = useState()
    const data = useStatementReport('statement', start, end)

  useEffect(() => {
    if (dates && Array.isArray(dates) && dates[0]) {
      setStart(Moment(dates[0]).format('YYYY-MM-DD'))
    }
    if (dates && Array.isArray(dates) && dates[1]) {
      setEnd(Moment(dates[1]).format('YYYY-MM-DD'))
    }

  },[dates, setStart, setEnd])

  const handleExportCsv = () => {
    if (!data.data?.data) return;

    const rows = data.data.data;
    const header = ["Metodo de Pagamento", "Total"];

    const csvContent = [
        header.join(";"),
        ...rows.map((item) =>
            [
              item.method,
              item.total_amount,
            ].join(";")
        )
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `relatorio-recebimentos-por-metodo-pagamento-${Moment(start).format('DD-MM-YYYY')}.csv`;
    link.click();
  };

  const onClick = () => {

  }

  return (
    <>
      <Container maxW="90%">
        <Flex justifyContent="space-between" alignItems="center">
            <Heading>Valores Por Método de Pagamento</Heading>
            <ButtonGroup size="xs">
                <IconButton
                    icon={<RepeatIcon />}
                    aria-label="Recarregar"
                    isLoading={data.isFetching}
                    onClick={data.refetch}
                />
                <IconButton
                    icon={<FaFileCsv />}
                    aria-label="Exportar CSV"
                    onClick={handleExportCsv}
                    isDisabled={data.isFetching || !data.data?.data?.length}
                    colorScheme="blue"
                />
            </ButtonGroup>
        </Flex>
        <Center mb={12}>
          <Form.Interval onSelect={setDates} label={"Data para o Relatório"} />
        </Center>
        <Table id="statement" border={1} columns={[{ children: 'Método de Pagamento' }, {children: 'Total', isNumeric: true}]} loading={data.isFetching}>
          { data.data?.data?.map(item => <Item key={item.order_id} data={item} onClick={onClick} />) }
        </Table>
      </Container>
    </>
  )

}

const Item = ({ data, onClick = () => {} }) => {
    return(
    <Row onClick={() => onClick(data)}>
        <Td children={data?.method} />
        <Td isNumeric><Badge children={`R$ ${Mask.price(data?.total_amount)}`} /></Td>
    </Row>
    )
}
